//const packageConstants = require('../../../../../package.json');
import packageConstants from '../../../../../package.json';
export const APP_VERSION = packageConstants['version'];
export const DEV_APP_VERSION = packageConstants['dev-version'];
